import axios from 'axios';
import {
  GET_REINFORCEMENTS,
  GET_REINFORCEMENTS_LIST,
  GET_REINFORCEMENTS_MINIMAL,
  GET_REINFORCEMENT,
  ADD_REINFORCEMENT,
  DELETE_REINFORCEMENT,
  UPDATE_REINFORCEMENT,
  REINFORCEMENTS_LOADING,
  REINFORCEMENT_LOADING,
  CLEAR_CURRENT_REINFORCEMENT,
  SET_REINFORCEMENTS_PAGE
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get lightweight reinforcements list with pagination and filtering (for table display)
export const getReinforcementsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setReinforcementsLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;
  
  if (filters.title && filters.title.length > 0) {
    queryParams += `&title=${filters.title.join(',')}`;
  }
  if (filters.tags && filters.tags.length > 0) {
    queryParams += `&tags=${filters.tags.join(',')}`;
  }

  axios
    .get(`/api/reinforcements/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_REINFORCEMENTS_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get single reinforcement by ID (for view/edit pages)
export const getReinforcement = (id) => (dispatch, getState) => {
  dispatch(setReinforcementLoading());
  axios
    .get(`/api/reinforcements/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_REINFORCEMENT, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current reinforcement
export const clearCurrentReinforcement = () => {
  return { type: CLEAR_CURRENT_REINFORCEMENT };
};

// Get minimal reinforcements list (for dropdowns/selectors - returns only _id and title)
export const getReinforcementsMinimal = () => (dispatch, getState) => {
  dispatch(setReinforcementsLoading());
  axios
    .get('/api/reinforcements/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_REINFORCEMENTS_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// DEPRECATED: Use getReinforcementsList() instead
export const getReinforcements = () => (dispatch, getState) => {
  dispatch(setReinforcementsLoading());
  axios
    .get('/api/reinforcements', tokenConfig(getState))
    .then(res => dispatch({ type: GET_REINFORCEMENTS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addReinforcement = reinforcement => (dispatch, getState) => {
  axios
    .post('/api/reinforcements', reinforcement, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_REINFORCEMENT, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const updateReinforcement = (id, reinforcement) => (dispatch, getState) => {
  axios
    .put(`/api/reinforcements/${id}`, reinforcement, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_REINFORCEMENT, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const deleteReinforcement = id => (dispatch, getState) => {
  axios
    .delete(`/api/reinforcements/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_REINFORCEMENT, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const setReinforcementsLoading = () => {
  return { type: REINFORCEMENTS_LOADING };
};

export const setReinforcementLoading = () => {
  return { type: REINFORCEMENT_LOADING };
};

// Set current page number (without fetching data)
export const setReinforcementsPage = (page) => {
  return { type: SET_REINFORCEMENTS_PAGE, payload: page };
};